import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAnchor, MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { take } from 'rxjs';
import { UserService } from 'src/app/core/services/user.service';
import { LoadingSpinnerModule } from 'src/app/shared/design-system/loading-spinner/loading-spinner.module';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'aoe-create-account-dialog',
  imports: [MatDialogModule, MatFormFieldModule, LoadingSpinnerModule, ReactiveFormsModule, MatInputModule, MatAnchor, MatButtonModule],
  templateUrl: './create-account-dialog.component.html',
  styleUrl: './create-account-dialog.component.scss',
})
export class CreateAccountDialogComponent {

  form!: FormGroup;

  constructor(
    readonly fb: FormBuilder,
    private readonly userService: UserService,
  ) {
    this.form = fb.group({
      firstName: new FormControl<string>('', { nonNullable: true, validators: [Validators.required, Validators.minLength(2)] }),
      lastName: new FormControl<string>('', { nonNullable: true, validators: [Validators.required, Validators.minLength(2)] }),
      password: new FormControl<string>('', { nonNullable: true, validators: [Validators.required, Validators.minLength(8)] }),
      mail: new FormControl<string>('', { nonNullable: true, validators: [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/), Validators.required] },)
    })

    this.form.valueChanges.subscribe(() => console.log(this.form));
  }

  get isFormValid() {
    return this.form.valid;
  }

  onSubmit() {
    this.userService.createUser({ ...this.form.value, appId: environment.appId }).pipe(take(1)).subscribe({
      next: (d) => alert(d),
      // error: (e) => 
    })
  }

}
